import { apiSlice } from "./apiSlice";

export const contactUsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    deleteContactUs: builder.mutation({
      query: (id) => ({
        url: `/contactUs/deleteContactUs/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContactUs"],
    }),

    markAsRead: builder.mutation({
      query: (id) => ({
        url: `/contactUs/markAsRead/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: ["ContactUs"],
    }),

    markAllAsRead: builder.mutation({
      query: () => ({
        url: `/contactUs/markAllAsRead`,
        method: "PATCH",
      }),
      invalidatesTags: ["ContactUs"],
    }),

    getAllMessages: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/contactUs/getAllMessages?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["ContactUs"],
    }),
    getMessageById: builder.query({
      query: (id) => ({
        url: `/contactUs/getMessageById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useDeleteContactUsMutation,
  useGetAllMessagesQuery,
  useMarkAllAsReadMutation,
  useMarkAsReadMutation,
  useGetMessageByIdQuery,
} = contactUsApi;
